import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * Presence Sensor Icon Style 01 - Sensor Occupied / All Out (Material Symbol)
 * - isOn = true (occupied): 紅色實心 + 脈衝動畫
 * - isOn = false (unoccupied): 綠色空心
 * 
 * @see https://fonts.google.com/icons?selected=Material+Symbols+Outlined:sensor_occupied
 * @see https://fonts.google.com/icons?selected=Material+Symbols+Outlined:all_out
 */
export const Style01_SensorOccupied: React.FC<DeviceIconProps> = ({ 
  isOn = false, 
  size = 'small',
  className = '',
  animated = true,
}) => {
  const pixelSize = getSizeInPixels(size);
  const colorClass = isOn ? 'text-red-500' : 'text-green-500';
  const animationClass = isOn && animated ? 'presence-pulse' : '';
  const iconName = isOn ? 'sensor_occupied' : 'all_out';

  return (
    <span 
      className={`material-symbols-outlined ${colorClass} ${animationClass} ${className}`}
      style={{ 
        fontSize: `${pixelSize}px`,
        fontVariationSettings: `'FILL' ${isOn ? 1 : 0}, 'wght' 400, 'GRAD' 0, 'opsz' 24`
      }}
    >
      {iconName}
    </span>
  );
};

export default Style01_SensorOccupied;
